import {
    postCustomerMobileAuthNumberReducer,
    postCustomerMobileAuthOtpReducer,
} from '../../slices/gq-customer';

export const gqCustomerMobileAuthReducers = {
    postCustomerMobileAuthNumber: postCustomerMobileAuthNumberReducer,
    postCustomerMobileAuthOtp: postCustomerMobileAuthOtpReducer
};
